var map = {
	"./compare": 8,
	"./compare.js": 8,
	"./dashboard": 19,
	"./dashboard.js": 19,
	"./newtask": 4,
	"./newtask.js": 4,
	"./notifications": 7,
	"./notifications.js": 7,
	"./persons": 9,
	"./persons.js": 9,
	"./progress": 3,
	"./progress.js": 3,
	"./projects": 20,
	"./projects.js": 20,
	"./settings": 5,
	"./settings.js": 5,
	"./statistics": 10,
	"./statistics.js": 10,
	"./tasks": 1,
	"./tasks.js": 1,
	"./time": 2,
	"./time.js": 2,
	"./toolbar": 6,
	"./toolbar.js": 6,
	"./top": 21,
	"./top.js": 21
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 30;